import { createSelector } from '@ngrx/store';
import { surveyCreationFeature } from '../survey-creation.feature';

const { selectAudience } = surveyCreationFeature;

export const selectSurveyId = createSelector(
  selectAudience,
  ({ surveyId }) => surveyId,
);

export const selectSurvey = createSelector(
  selectAudience,
  ({ survey }) => survey,
);

export const selectMetadataForm = createSelector(
  selectAudience,
  ({ metadata }) => metadata,
);

export const selectQualificationsForm = createSelector(
  selectAudience,
  ({ qualifications }) => qualifications,
);

export const selectQuotasForm = createSelector(
  selectAudience,
  ({ quotas }) => quotas,
);

export const selectSurveyFormState = createSelector(
  selectMetadataForm,
  selectQualificationsForm,
  selectQuotasForm,
  (metadata, qualifications, quotas) => ({ metadata, qualifications, quotas }),
);

export const selectError = createSelector(selectAudience, ({ error }) => error);

//SECTION SCORE
export const selectScorePercentage = createSelector(
  selectAudience,
  ({ score }) => score.scorePercentage,
);

export const selectScoreLoading = createSelector(
  selectAudience,
  ({ score }) => score.loading,
);

export const selectScoreError = createSelector(
  selectAudience,
  ({ score }) => score.error,
);
//!SECTION

//SECTION FEASIBILITY
export const selectFeasibilityTotal = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.total,
);

export const selectFeasibilityQuotaGroups = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.quotaGroups,
);

export const selectFeasibilityAudience = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.audience,
);

export const selectFeasibilityHasQuota = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.hasQuota,
);

export const selectFeasibilityLoading = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.loading,
);

export const selectFeasibilityError = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.error,
);
